import { LuSatellite } from 'react-icons/lu';
import className from './no-results.module.scss';

export default function NoResults() {
    return (
        <div className={className.base}>
            <LuSatellite />
            <div className={className.text}>No hay resultados</div>
        </div>
    );
}
